module.exports = __webpack_public_path__ + "media/feedback-2-93fa546457731aca0a7771f34c089b75.gif";